<template>
  <ParseForm ref='bus' :formParams='formParams' :formId='formId' :opCode='opCode'></ParseForm>
</template>

<script>
import ParseForm from '../../util/parseFormNew/ParseForm';

export default {
  name: 'ImsTemplate',
  props: {
    formParams: {
      type: Object,
      default(){
        return {
          formId: 'imsTemplate'
        }
      }
    },
    opCode: { type: String, default: '' }
  },
  data(){
    return {
      formId: this.formParams.formId
    }
  },
  methods:{
    getDatas() {
      return this.$refs.bus.getDatas();
    },
    validateResult() {
      return this.$refs.bus.validateResult();
    },
    setData(_name, _data) {
      this.$refs.bus.setData(_name, _data);
    }
  },
  components:{
    ParseForm
  }
}
</script>